import ProfileImage from '../Assests/ProfileImage.jpg';
import N8R_Games from '../Assests/N8R_Games.png';

const Landing = ({ aboutRef, expRef, projectsRef }) => {
	return (
		<>
			<div className='section-container'>
				<section className='section-content'>
					<h3 className='deco-text'>Hello, I am Ray Flores</h3>
					<h2 className='main-head-text'>Welcome to my personal website.</h2>
					<p>
						I am a skilled software engineer specializing in .NET development, currently focused on building an efficient and scalable ERP system for
						Us Conec, Ltd. My passion for engineering and drive for excellence enable me to create high-quality solutions that solve complex business
						challenges.
					</p>
				</section>
			</div>
			<div
				ref={aboutRef}
				className='section-container'
			>
				<section className='section-content'>
					<div className='column-container'>
						<div className='col-1'>
							<h2 className='main-head-text'>About Me</h2>
							<p>
								I am an enthusiastic programmer and engineer with a focus on backend development. I thrive on tackling complex systems that require
								critical thinking and logical problem-solving. My skillset includes C#, MSSQL, Jquery, AJAX, Bootstrap, and I am currently expanding
								my expertise to include ReactJS and integration with Amazon Web Services. I am flexible and adaptable, with experience in frontend
								development as well.{/*I am excited about the opportunity to use my skills and experience to contribute to your team's success. */}
							</p>
						</div>
						<div className='col-1'>
							<div className='about-card'>
								<img
									className='profile-img'
									alt='img'
									src={ProfileImage}
								/>
							</div>
						</div>
					</div>
				</section>
			</div>
			<div
				ref={expRef}
				className='section-container'
			>
				<section className='section-content'>
					<h2 className='deco-text'>US Conec</h2>
					<h3 className='listHeader main-head-text'>Worked directly with stakeholders from every department of US Conec:</h3>
					<ul>
						<li>Gathered project requirements</li>
						<li>Created project timelines</li>
						<li>Executed project deliverables</li>
						<li>Utilized Azure Devops to manage project tasks, work boards, and software releases</li>
					</ul>
					<h3 className='listHeader main-head-text'>Maintained and further developed an in-house full Enterprise Resource Planning (ERP):</h3>
					<ul>
						<li>Integrated processes across all business functions</li>
						<li>Functions included, but not limited to, inventory management, accounting, process logging, reporting, and document control</li>
						<li>
							Developed and maintained a custom API to integrate with a 3<sup>rd</sup> party scheduling software
						</li>
					</ul>
					<h3 className='listHeader main-head-text'>
						Developed system automation and optimization to eliminate 30% of labor required for various tasks and reports:
					</h3>
					<ul>
						<li>Continously reviewed processes to identify opportunities for improvement of the system</li>
						<li>Focused on creating intuitive design and removing redundant operations to increase efficiency</li>
						<li>Automated daily production reports and notifications</li>
					</ul>
				</section>
			</div>
			<div
				ref={projectsRef}
				className='section-container'
				style={{ paddingTop: '2.5rem' }}
			>
				<section className='section-content'>
					<h2 className='main-head-text'>Projects</h2>
					<div className='column-container'>
						<div
							className='project-card col-1'
							onClick={() => window.open('https://www.n8rgames.com', 'n8rgames')}
						>
							<img
								src={N8R_Games}
								alt='N8R Games'
								className='project-img'
							/>
							<div className='project-info'>
								<h3>N8R Games</h3>
								<p>Android mobile game development built with Unity 3D and C#</p>
							</div>
						</div>
					</div>
				</section>
			</div>
		</>
	);
};

export default Landing;
